import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
declare let $: any;
import * as Aos from 'aos';
import Swal from 'sweetalert2';
import { Buffer } from 'buffer';
// declare let Swiper: any;
// declare let bootstrap: any;
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.css']
})
export class SitemapComponent implements OnInit {


  constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute,private route: Router, public encDec: EncryptDecryptService,public translate: TranslateService) { }


  
  // headerMenus:any=[];
  // footerData:any=[];
  // totalfootermenu=0;
  menutimeInteval:any = null;
  language = sessionStorage.getItem('locale');//dynamic
  ngOnInit(): void {
 
    // let allHdrMenues:any = sessionStorage.getItem('ALL_HEADER_MENUES');
    // this.headerMenus = JSON.parse(allHdrMenues);


    // let allFooterData:any = window.sessionStorage.getItem("ALL_FOOTER_MENUES")
    // this.footerData =JSON.parse(allFooterData);
    // this.totalfootermenu =this.footerData.length;
    document.title = "Site Map";
    this.menutimeInteval = setInterval(():any=>{
      if(!this.fciwebservice.MenuData().progress){
        this.getallHeaderMenu();
        this.getallFooterMenu();
        clearInterval(this.menutimeInteval);
      }
    }, 500);
    }

  ngAfterViewInit(): void {
    //FOR SCROLLING TO TOP WHEN COMPONENT LOADS
    // $('html, body').scrollTop(0);
  }  
 
  goToContentPage(primaryHeader:any)
  {
      this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.route.navigate(['./view'+'/'+primaryHeader["menuAlias"]]));
   } 
  
  
    goToExtLink(url: any) {
      Swal.fire({
        title: 'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
        text: 'Are you sure?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          window.open(url, '_blank');
        }
      });
    }
  
    goToPluginPage(link: any, menudtl: any) {
      sessionStorage.removeItem(btoa(menudtl.selectPlugin));
      sessionStorage.setItem(btoa(menudtl.selectPlugin), JSON.stringify(menudtl));
      // this.route.navigate([link,""]);
      this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.route.navigate([link]));
    }
    htmldecode(str: any){
      return this.encDec.decodeHtml(str);
    }

    headerGlobalMenu: any[] = [];
    headerPrimaryMenu: any[] = [];
    getallHeaderMenu():boolean {
      this.headerGlobalMenu = [];
      this.headerPrimaryMenu = [];
      let allmenu:any = this.fciwebservice.getFilterMenus(1);
      if(allmenu.length <= 0){
        return false;
      }
      for (let loop of allmenu) {
        if (loop["menuType"] == 1) //Global Menu
        {
          this.headerGlobalMenu.push(loop);
        } else if (loop["menuType"] == 2) { //Secondary Menu
          this.headerPrimaryMenu.push(loop);
        }
      }
      return true;
    }




    footerGlobalMenu:any[]=[];
    footerPrimaryMenu:any[]=[];
    getallFooterMenu():boolean {
     this.footerGlobalMenu = [];
     this.footerPrimaryMenu = [];
     let allmenu:any = this.fciwebservice.getFilterMenus(2);
     if(allmenu.length <= 0){
       return false;
     }
     for(let loop of allmenu)
       {
           if(loop["menuType"]==1) //Global Menu
             {
               this.footerGlobalMenu.push(loop);
             } else if(loop["menuType"]==2){ //Secondary Menu
               this.footerPrimaryMenu.push(loop);
             }
       }
     return true;
    }
}